import { render, staticRenderFns } from "./UpdatePOS.vue?vue&type=template&id=060172fa"
import script from "./UpdatePOS.vue?vue&type=script&lang=js"
export * from "./UpdatePOS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports